import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import Footer from "components/Footer";
import NotFound from "pages/NotFound";
import { useGoogleAnalytics } from "./hooks/useGoogleAnalytics";
import UserLogin from './pages/user-login';
import TripConfirmation from './pages/trip-confirmation';
import TripDetailView from './pages/trip-detail-view';
import LandingPage from './pages/landing-page';
import UserDashboard from './pages/user-dashboard';
import UserProfileManagement from './pages/user-profile-management';
import TripReviewEdit from './pages/trip-review-edit';
import UserRegistration from './pages/user-registration';
import PDFGenerationDownload from './pages/pdf-generation-download';
import AITripPlanningInterface from './pages/ai-trip-planning-interface';
import TermsOfService from './pages/terms-of-service';
import PrivacyPolicy from './pages/privacy-policy';
import EmailVerificationSuccess from './pages/email-verification-success';

function RoutesWithAnalytics() {
  // Initialize Google Analytics inside Router context
  useGoogleAnalytics();

  return (
    <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/user-login" element={<UserLogin />} />
        <Route path="/trip-confirmation" element={<TripConfirmation />} />
        <Route path="/trip-detail-view/:tripId" element={<TripDetailView />} />
        <Route path="/landing-page" element={<LandingPage />} />
        <Route path="/user-dashboard" element={<UserDashboard />} />
        <Route path="/user-profile-management" element={<UserProfileManagement />} />
        <Route path="/trip-review-edit" element={<TripReviewEdit />} />
        <Route path="/user-registration" element={<UserRegistration />} />
        <Route path="/pdf-generation-download" element={<PDFGenerationDownload />} />
        <Route path="/ai-trip-planning-interface" element={<AITripPlanningInterface />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/email-verification-success" element={<EmailVerificationSuccess />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      <Footer />
    </ErrorBoundary>
  );
}

export default function ProjectRoutes() {
  return (
    <BrowserRouter>
      <RoutesWithAnalytics />
    </BrowserRouter>
  );
}